import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useAppContext } from "utils/store";
import { apiWrapper } from "apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { API_HOST } from "Constants";
import { useReactToPrint } from "react-to-print";
import FireOnToolbar from "./FireOnToolbar";

//건축물 현황
export default function BuildingStatusComponent(props) {
    const printRef = useRef();
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: "건축물 현황",
    });

    return (
        <>
            <div className="viewBoard fireOnBoard bsBoard">
                <TopBoard currentDateTime={props.currentDateTime} />
                <MidBoard handlePrint={handlePrint} />
                <BuildingStatusBoard printRef={printRef} />
                <FireOnToolbar item="건축물현황" buildingName={buildingName} serialNumber={serialNumber} dei={dei} />
            </div>
        </>
    );
}

const TopBoard = ({ currentDateTime }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { store: { userName } } = useAppContext();
    const location = useLocation();

    const handleGoBack = () => {
        navigate(`/fire-on/alarm-monitor/${id}`, location.state);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo" /> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="#">
                            <img src="/images/my_btn_mb_w.png" alt="" />
                        </Link>
                    </div>
                </div>
            </div>

            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">건축물 현황</p>
                </div>
                <div className="wrap_right pc">
                    <div className="wrap_userBox">
                        <div className="wrap_userInfo pc">
                            <p className="current_date">{currentDateTime}</p>
                        </div>
                        <p className="user_id">{userName}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

const MidBoard = ({ handlePrint }) => {
    const location = useLocation();
    const { buildingName } = location.state;

    return (
        <div className="mid_board">
            <div className="wrap_mid_le">
                <p className="title_mid">{buildingName}</p>
            </div>
            <div class="wrap_right">
                <button class="btn_contr btn-print" onClick={handlePrint}>인쇄</button>
            </div>
        </div>
    );
};

const BuildingStatusBoard = forwardRef(({ printRef }) => {
    const { id } = useParams();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [dataSource, setDataSource] = useState(null);

    useEffect(() => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getFireFightingObjectBuildingStatus(id);
            if (status === true) {
                setDataSource(data);
            } else {
                alert(`${data}`);
            }
        });
    }, []);

    const handleChangeImage = (index) => {
        setSelectedIndex(index);
    }

    return (
        <div ref={printRef} className="col_board buildingStatusBoard" >
            {dataSource && (
                <>
                    <div className="wrap_photo">
                        {dataSource.photos.length > 0 ? (
                            <>
                                <div className="main_photo">
                                    <img id="mainImage" src={API_HOST + dataSource.photos[selectedIndex].photoImage} alt="" />
                                </div>
                                <div className="wrap_album">
                                    <div className="inner_album active">
                                        {dataSource.photos.map((item, index) => (
                                            <div className={`item_album ${selectedIndex === index ? 'active' : ''}`} key={index} onClick={() => handleChangeImage(index)}>
                                                <img src={API_HOST + item.photoImage} alt="" />
                                            </div>
                                        ))}
                                        {/* 빈 자리 채우기 */}
                                        {Array.from({ length: Math.max(0, 3 - dataSource.photos.length) }).map((_, idx) => (
                                            <div className="item_album empty" key={`empty-${idx}`}>
                                                <p>이미지 없음</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="main_photo" style={{ display: "flex", justifyContent: "center", top: '50%' }}>
                                <p>
                                    등록된 건물 사진이 없습니다.
                                </p>
                            </div>
                        )}
                    </div>
                    <StatusDetails printRef={printRef} dataSource={dataSource} />
                </>
            )}
        </div >
    );
});

const StatusDetails = ({ printRef, dataSource }) => {
    const { basicInfo, floorDetails } = dataSource;

    return (
        <div className="wrap_status">
            <div className="box_status">
                {basicInfo && (
                    <>
                        <div class="row_input">
                            <div class="item_status">
                                <p class="title_status">건물 명</p>
                                <p class="cont_status">{basicInfo.name}</p>
                            </div>
                            <div class="item_status">
                                <p class="title_status">주소</p>
                                <p class="cont_status">{basicInfo.address}</p>
                            </div>
                        </div>
                        <div class="row_input">
                            <div class="item_status">
                                <p class="title_status">주용도</p>
                                <p class="cont_status">{basicInfo.mainUse}</p>
                            </div>
                            <div class="item_status">
                                <p class="title_status">주구조</p>
                                <p class="cont_status">{basicInfo.mainStructure}</p>
                            </div>
                        </div>
                        <div class="row_input">
                            <div class="item_status">
                                <p class="title_status">준공일</p>
                                <p class="cont_status">{basicInfo.completionDate}</p>
                            </div>
                            <div class="item_status">
                                <p class="title_status">사용승인일</p>
                                <p class="cont_status">{basicInfo.approvalDate}</p>
                            </div>
                        </div>
                        <div class="row_input">
                            <div class="item_status">
                                <p class="title_status">층수</p>
                                <p class="cont_status">{basicInfo.floorCount}</p>
                            </div>
                            <div class="item_status">
                                <p class="title_status">연면적</p>
                                <p class="cont_status">{basicInfo.totalFloorArea}</p>
                            </div>
                        </div>
                        <div class="row_input">
                            <div class="item_status">
                                <p class="title_status">건물면적</p>
                                <p class="cont_status">{basicInfo.buildingArea}</p>
                            </div>
                            <div class="item_status">
                                <p class="title_status">용적율</p>
                                <p class="cont_status">{basicInfo.floorAreaRatio}</p>
                            </div>
                        </div>
                        <div class="row_input">
                            <div class="item_status">
                                <p class="title_status">지붕구조</p>
                                <p class="cont_status">{basicInfo.roofStructure}</p>
                            </div>
                            <div class="item_status">
                                <p class="title_status">소방안전관리자</p>
                                <p class="cont_status">{basicInfo.safetyManager}</p>
                            </div>
                        </div>
                    </>
                )}
            </div>
            {floorDetails && (
                <BuildingStatusTable dataSource={floorDetails} />
            )}
        </div>
    );
};

const BuildingStatusTable = ({ dataSource }) => {
    return (
        <div className="table_board">
            <div className="containerTable buildingStatusTable">
                <ul className="head_table">
                    <li><p>구분</p></li>
                    <li><p>층별</p></li>
                    <li><p>구조</p></li>
                    <li><p>용도</p></li>
                    <li><p>면적</p></li>
                </ul>
                <div className="body_table">
                    <div className="inner_table_wrap">
                        {dataSource &&
                            dataSource.map((item, index) => (
                                <div className="wrap_table_item" key={index}>
                                    <div className="inner_table_item table_item_01">
                                        <p className="cont_table_item">{item.category}</p>
                                    </div>
                                    <div className="inner_table_item table_item_02">
                                        <p className="cont_table_item">{item.floor}</p>
                                    </div>
                                    <div className="inner_table_item table_item_03">
                                        <p className="cont_table_item">{item.structure}</p>
                                    </div>
                                    <div className="inner_table_item table_item_04">
                                        <p className="cont_table_item">{item.use}</p>
                                    </div>
                                    <div className="inner_table_item table_item_05">
                                        <p className="cont_table_item">{item.area}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};